
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist-application",
      function () {
        return require("private-next-pages/artist-application/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist-application"])
      });
    }
  